import * as PIXI from 'pixi.js';
import { Emitter } from 'pixi-particles';
import { gsap } from 'gsap';

/**
 * 雲のパーティクル
 */
export default class Cloud {
    constructor(json, textures, owner) {
        this.json = json;
        this.textures = textures;
        this.owner = owner;
        this.init();
    }

    render() {
        this.update();
    }

    pause() {
        cancelAnimationFrame(this.raf);
    }

    init() {
        this.app = null;
        this.container = null;
        this.emitter = null;
        this.elapsed = 0;
        this.req = 0;
        this.ww = $(window).width();
        this.wh = 150;

        this.$owner = $(this.owner);
        this.$target = this.$owner.find('.js-cloud-pixi');
        this.$image = this.$owner.find('.js-cloud-image');

        this.createPixi();
    }

    /**
     * PIXI APP の作成
     */
    createPixi() {
        this.app = new PIXI.Application({ transparent: true }, this.ww, this.wh);
        this.$target.append(this.app.view);

        this.container = new PIXI.Container();
        this.emitter = new Emitter(this.container, this.textures, this.json.data);
        this.emitter.emit = true;

        this.elapsed = Date.now();
        this.update();

        window.addEventListener('resize', this.resize.bind(this));
        this.resize();
    }

    /**
     * 更新処理
     */
    update() {
        if (this.app == undefined) return;

        // pixiの更新
        this.req = requestAnimationFrame(this.update.bind(this));
        const now = Date.now();
        this.emitter.update((now - this.elapsed) * 0.001);
        this.elapsed = now;
        this.app.renderer.render(this.container);

        // 雲画像のループ
        gsap.set(this.$image, { backgroundPositionX: '+=0.02' });
    }

    resize() {
        if (this.app == undefined) return;
        this.ww = $(window).width();

        const $canvas = this.$target.find('canvas');
        $canvas.width = this.ww;
        $canvas.height = this.wh;
        this.app.renderer.resize(this.ww, this.wh);
        this.emitter.spawnRect.width = this.ww;
    }
}
